<br>

<div class="form-row btntop col-sm-12 d-flex align-items-center" style="margin-top: 10px;">
  <div class="d-flex justify-content-start w-100">
    <div class="d-flex align-items-center gap-2 w-100">
      
      <!-- Knapparna -->
      <div class="d-flex gap-1">
        <button class="btn border" [disabled]="!birthdayform.valid" (click)="generateReport()">Sök</button>
        <button class="btn border" (click)="clear()">Rensa</button>
      </div>

      <!-- Labeln -->
      <p class="reportlabel mb-0 ms-3">Rapport: Födelsedagslista</p>

    </div>
  </div>
</div>

<div class="d-flex justify-content-start ms-4">
  <form [formGroup]="birthdayform">

        <mat-expansion-panel [expanded]=true>
          <mat-expansion-panel-header [expandedHeight]="'48px'">
            <mat-panel-title>
              Födelsedagslista
            </mat-panel-title>
            <mat-panel-description>

            </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="d-flex justify-content-start gap-2">
            <div class="form-group">
              <label for="institutionId">Välj institution</label>
              <select class="form-control form-control-sm" id="institutionId" formControlName="institutionId" required>
                <option></option>
                <option *ngFor="let i of institutionlist" [ngValue]="i.id">{{i.shortName}} - {{i.name}}</option>
              </select>
            </div>

            <div class="form-group">
              <label for="year">
                År
              </label>
              <input type="text" class="form-control form-control-sm" id="year" style="max-width:80px;" formControlName="year" required>
            </div>
          </div>
          
          <br>
          <p-menubar *ngIf="birthdays.length" [model]="items">
            <div style="margin-top:5px;margin-right:10px;">
              Resultat: {{birthdays?.length}}
          </div>
          </p-menubar>
          <br>
          <div class="row container" id="contentToConvert" *ngIf="birthdays.length > 0">
            <table class="table" matSort (matSortChange)="sortData($event)" matSortDisableClear=true style="min-width: 700px;">
              <thead class="border-none">
                <tr style="text-align: left;">
              <th mat-sort-header="birthday" style="text-align: left;padding:0px;">Födelsedatum</th>
              <th mat-sort-header="year">Antal år</th>
              <th mat-sort-header="givenname">Förnamn</th>
              <th mat-sort-header="familyname">Efternamn</th>
              <th mat-sort-header="id">Medlemsnr</th>
              <th mat-sort-header="celebrationdate">Högtidsdag</th>
              </tr>
              </thead>
              
              <tr *ngFor="let b of birthdays">
                <td>{{b.birthday | date: "yyyy-MM-dd"}}</td>
                <td>{{b.year}}</td>
                <td>{{b.givenName}}</td>
                <td>{{b.familyName}}</td>
                <td> <a [routerLink]="['/memberform/id/', b.id]">{{b.id}}</a></td>
                <td>{{b.celebrationDate}}</td>
              </tr>
            </table>
          </div>

        </mat-expansion-panel>
      
  </form>
</div>


